/* Sleep LP How-To — modal video playback
   Loop videos run muted in the background. Clicking the play button
   opens a modal and plays the full video with sound. */
(function () {
  'use strict';

  function initSection(root) {
    var modal = root.querySelector('[data-howto-modal]');
    var modalVideo = root.querySelector('[data-howto-modal-video]');
    var closers = root.querySelectorAll('[data-howto-close]');

    function open(html, src) {
      if (!modal || !modalVideo) return;
      modalVideo.innerHTML = '';
      if (html) {
        modalVideo.innerHTML = html;
        var v = modalVideo.querySelector('video');
        if (v) { v.muted = false; v.play().catch(function () {}); }
      } else if (src) {
        var video = document.createElement('video');
        video.src = src;
        video.controls = true;
        video.autoplay = true;
        video.muted = false;
        video.playsInline = true;
        modalVideo.appendChild(video);
      }
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function close() {
      if (!modal || !modalVideo) return;
      modal.hidden = true;
      modalVideo.innerHTML = '';
      document.body.style.overflow = '';
    }

    root.querySelectorAll('[data-howto-play]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('.sleep-howto__card');
        var index = Array.prototype.indexOf.call(root.querySelectorAll('.sleep-howto__card'), card);
        var template = root.querySelector('[data-howto-full="' + index + '"]');
        var html = template ? template.innerHTML : '';
        var src = btn.dataset.fullSrc || '';
        open(html, src);
      });
    });

    closers.forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) close();
    });
  }

  function init() {
    document.querySelectorAll('[data-sleep-howto]').forEach(initSection);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll && e.target.querySelectorAll('[data-sleep-howto]').forEach(initSection);
  });
})();
